<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">
            Disposiciónes realizadas
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes revisar todas las disposiciones realizadas a los clientes en sus líneas de crédito.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="3" class="pl-0">
          <v-text-field
            v-model="search"
            label="Buscar disposición"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
        <v-spacer/>
        <v-btn color="black" class="white--text" rounded style="font-family: 'montserrat-bold'; margin-left: 10px;"
          :disabled="drawsSeleccionados.length === 0"
          @click="dialogPago = true, selectedDraw = drawsSeleccionados[0]"
          >
          Realizar cobro
        </v-btn>
      </v-row>

      <!-- Tabla de draws -->
      <v-data-table
        class="d-none d-sm-block"
        :items="filteredDraws"
        hide-default-header
        >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left"></th>
              <th class="header__title center">Id</th>
              <th class="header__title center">Cliente</th>
              <th class="header__title center">Monto solicitado</th>
              <th class="header__title center">Monto dispersado</th>
              <th class="header__title center">Fecha dispersado</th>
              <th class="header__title center">Monto pagado</th>
              <th class="header__title center">Monto pendiente</th>
              <th class="header__title center">Status</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">
                <v-checkbox
                  color="black"
                  v-model="drawsSeleccionados"
                  :value="item"
                  :disabled="item.remaining_principal == 0 || (clienteSeleccionado && item.sEnterpriseId !== clienteSeleccionado)"
                ></v-checkbox>
              </td>
              <td class="table__item">{{ item.id }}</td>
              <td class="table__item">{{ item.enterprise_name }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.draw_amount) + " " + item.credit_line_currency }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.disbursed_amount) + " " + item.disbursed_currency }}</td>
              <td class="table__item">{{ formatDate(item.disbursed_at) }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.principal_paid_total) + " " + item.credit_line_currency }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.remaining_principal) + " " + item.credit_line_currency }}</td>
              <td class="table__item">
                <v-chip :color="item.status === 'repaid' ? 'green' : 'red'" small dark>
                  {{ item.status }}
                </v-chip>
              </td>
              <td class="table__item center">
                <v-tooltip v-if="item.has_receipt" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="black" @click="viewReceipt(item)">
                      <v-icon>mdi-cash-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Comprobante de pago</span>
                </v-tooltip>
                <v-tooltip v-if="item.has_payment_receipt" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="black" @click="viewPaymentReceipt(item)">
                      <v-icon>mdi-file-document-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Comprobante de cobro</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogPago" max-width="1000px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 14px; text-align: end;">
            1. Selecciona la fecha del cobro para calcular los intereses generados hasta esa fecha.
          </div>
          <v-card-title style="font-family: 'montserrat-bold'; font-size: 22px;">
            Registrar Cobro
            <v-spacer />
            <v-col cols="4">
              <v-text-field
                v-model="nuevoPago.fecha"
                label="Fecha del cobro"
                type="date"
                outlined
                hide-details
                rounded
                @change="calcularInteresesGenerados"
              />
            </v-col>
          </v-card-title>
          <v-divider class="my-4" />
          <v-row class="mb-2" v-if="nuevoPago.fecha">
            <v-col cols="12">
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">
                Cliente: {{ drawsSeleccionados[0]?.enterprise_name || '—' }}
              </div>
            </v-col>
            <v-row dense class="mb-4" style="font-family: 'montserrat-bold';">
              <v-col cols="4" class="" style="font-family: 'montserrat-bold'; font-size: 16px; align-self: center;">
                Total adeudado: 
                <span style="font-weight: bold;">
                  $ {{ formatMoney(totalAdeudado) }} USD
                </span>
              </v-col>
              <v-spacer/>
              
              <v-col cols="4">
                <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 14px; text-align: end;">
                  2. Selecciona el monto que abonó el cliente.
                </div>
                <v-text-field
                  v-model.number="nuevoPago.monto"
                  :disabled="nuevoPago.fecha === null"
                  label="Monto del cobro"
                  outlined
                  class="mt-2"
                  hide-details
                  :loading="loadingInterest"
                  rounded
                  prefix="$"
                />
              </v-col>
            </v-row>
            <!-- Tabla -->
            <v-col cols="12">
              <v-data-table
                :headers="headersPagoDisposiciones"
                :items="drawsSeleccionados"
                disable-pagination
                hide-default-footer
                dense
              >
                <template v-slot:item.remaining_principal="{ item }">
                  $ {{ formatMoney(item.remaining_principal || 0) + " " + item.credit_line_currency }}
                </template>
                <template v-slot:item.interes_calculado="{ item }">
                  $ {{ formatMoney(item.interes_calculado || 0) + " " + item.credit_line_currency }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon color="black" @click="dialogUpdateInterest = true, selectedDraw = item">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ "Editar interés generado" }}</span> 
                  </v-tooltip>
                </template>
                <template v-slot:item.capitalAsignado="{ item }">
                  <v-text-field
                    v-model.number="item.capitalAsignado"
                    :disabled="Number(nuevoPago.monto) < sumaIntereses || nuevoPago.monto === null"
                    type="number"
                    hide-details
                    dense
                    style="max-width: 120px;"
                    min="0"
                    :max="item.remaining_principal"
                  />
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <!-- Monto total del pago -->
          

          <!-- Validaciones -->
          <v-row class="mb-2" v-if="nuevoPago.monto">
            
            <v-col cols="12" style="font-family: 'montserrat-bold'; font-size: 14px;">
              <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 14px;">
                3. Revisa el resumen del cobro antes de registrarlo. El monto total del cobro debe ser igual a la suma de intereses y capital asignado.
              </div>
              <div>Intereses: ${{ formatMoney(sumaIntereses) }}</div>
              <div>Capital asignado: ${{ formatMoney(sumaCapitales) }}</div>
              <div class="mt-2" :style="{ color: validacionPago ? 'green' : 'red' }">
                Total asignado: ${{ formatMoney(sumaIntereses + sumaCapitales) }} / Pendiente de asignar: ${{ formatMoney(nuevoPago.monto - sumaIntereses - sumaCapitales) }}
              </div>
            </v-col>
          </v-row>

          <v-row dense class="mb-2">
            <v-col cols="12">
              <v-file-input
                v-model="receiptFile"
                label="Comprobante de cobro (PDF)"
                accept=".pdf"
                outlined
                style="border-radius: 10px;"
                hide-details
                prepend-icon="mdi-paperclip"
              />
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <v-card-actions class="justify-end" style="font-family: 'montserrat-bold';">
            <v-btn text @click="dialogPago = false, nuevoPago = { fecha: null, monto: null }, drawsSeleccionados = [], receiptFile = null" rounded>Cancelar</v-btn>
            <v-btn
              color="black"
              rounded
              class="white--text px-4"
              :disabled="!validacionPago"
              @click="registrarPago"
            >
              Registrar Cobro
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateInterest" v-if="dialogUpdateInterest" max-width="500px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-card-title style="font-family: 'montserrat-bold'; font-size: 22px;">
            Modificar interés generado
          </v-card-title>
          <v-divider class="my-4" />
          <v-col cols="12">
            <v-text-field
              v-model.number="selectedDraw.interes_calculado"
              label="Interés generado"
              outlined
              hide-details
              rounded
              prefix="$"
            />
          </v-col>
          <v-divider class="my-4" />
          <v-card-actions class="justify-end" style="font-family: 'montserrat-bold';">
            <v-btn text @click="dialogUpdateInterest = false, selectedDraw = null" rounded>Cancelar</v-btn>
            <v-btn
              color="black"
              rounded
              class="white--text px-4"
              @click="dialogUpdateInterest = false, selectedDraw = null"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      isLoading: false,
      loadingInterest: false,
      status: "all",
      draws: [],
      drawsSeleccionados: [],
      dialogPago: false,
      dialogUpdateInterest: false,
      selectedDraw: null,
      receiptFile: null,
      nuevoPago: {
        fecha: null,
        monto: null
      },
      interesesCalculados: null
    };
  },
  methods: {
    async viewPaymentReceipt(item) {
      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/credit_draws/${item.id}/payment-receipts`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        // Abrir todos los comprobantes de cobro asociados
        res.data.receipts.forEach(r => window.open(r.url, '_blank'));
      } catch (err) {
        this.$toast.error('Error al obtener comprobante de cobro');
      }
    },
    async viewReceipt(item) {
      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/credit_draws/${item.id}/receipt`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        window.open(res.data.url, '_blank');
      } catch (err) {
        this.$toast.error('Error al obtener el comprobante');
      }
    },
    async getDraws() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/admin/credit/credit_draws/?status=${this.status}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.draws = response.data.creditDraws;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async calcularInteresesGenerados() {
      if (!this.nuevoPago.fecha || !this.drawsSeleccionados.length) return;

      this.loadingInterest = true;

      try {
        const interestResults = await Promise.all(
          this.drawsSeleccionados.map(async (draw) => {
            const res = await DB.get(`${URI}/api/v1/en/admin/credit/credit_draw_payments/${draw.id}/interest-summary`, {
              params: { as_of: this.nuevoPago.fecha },
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            });
            return {
              ...draw,
              interes_calculado: res.data.data.interest_accrued,
            };
          })
        );

        this.drawsSeleccionados = interestResults;
      } catch (err) {
        this.$toast.error("No se pudieron calcular los intereses.");
      } finally {
        this.loadingInterest = false;
      }
    },
    // async registrarPago() {
    //     console.log(this.drawsSeleccionados);
    //   try {
    //     await DB.post(`/api/v1/en/admin/credit/credit_draws`, {
    //       amount: Number(this.nuevoPago.monto),
    //       payment_date: this.nuevoPago.fecha
    //     });
    //     console.log(this.drawsSeleccionados);
    //     this.$toast.success("Pago registrado con éxito.");
    //     this.dialogPago = false;
    //     this.getDraws(); // o la función que refresca tu vista
    //   } catch (err) {
    //     this.$toast.error("Error al registrar el pago.");
    //   }
    // },
    async registrarPago() {
      try {
        const applications = this.drawsSeleccionados.map(draw => ({
          credit_draw_id: draw.id,
          interest_paid: Number(draw.interes_calculado || 0),
          principal_paid: Number(draw.capitalAsignado || 0)
        }));

        // Validación local
        const sumaAplicaciones = applications.reduce(
          (acc, a) => acc + a.interest_paid + a.principal_paid,
          0
        );

        if (Math.abs(sumaAplicaciones - Number(this.nuevoPago.monto)) > 0.01) {
          this.$toast.error("La suma de intereses y capital asignado no coincide con el monto total.");
          return;
        }

        const formData = new FormData();
        formData.append('payment_date', this.nuevoPago.fecha);
        formData.append('total_amount', Number(this.nuevoPago.monto));
        formData.append('applications', JSON.stringify(applications));
        if (this.receiptFile) {
          formData.append('receipt_file', this.receiptFile);
        }

        // Enviar al backend
        const res = await DB.post(`${URI}/api/v1/en/admin/credit/credit_draw_payments/pay`, formData, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
            'Content-Type': 'multipart/form-data',
          }
        });

        this.$toast.success("Cobro registrado exitosamente.");
        this.dialogPago = false;
        this.nuevoPago = { fecha: null, monto: null };
        this.receiptFile = null;
        this.draws = [];
        this.drawsSeleccionados = [];
        this.getDraws();
      } catch (err) {
        console.error("Error al registrar cobro:", err);
        this.$toast.error("Error al registrar el cobro.");
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
  },
  computed: {
    clienteSeleccionado() {
      return this.drawsSeleccionados.length > 0
        ? this.drawsSeleccionados[0].sEnterpriseId
        : null;
    },
    sumaIntereses() {
      return this.drawsSeleccionados.reduce((acc, d) => acc + Number(d.interes_calculado || 0), 0);
    },
    sumaCapitales() {
      return this.drawsSeleccionados.reduce((acc, d) => acc + Number(d.capitalAsignado || 0), 0);
    },
    totalAdeudado() {
      return this.drawsSeleccionados.reduce((acc, draw) => {
        const saldoRestante = Number(draw.remaining_principal || 0);
        const interesGenerado = Number(draw.interes_calculado || 0);
        return acc + saldoRestante + interesGenerado;
      }, 0);
    },
    validacionPago() {
      const total = Number(this.nuevoPago.monto || 0);
      return (
        total >= this.sumaIntereses &&
        parseFloat(total.toFixed(2)) === parseFloat((this.sumaIntereses + this.sumaCapitales).toFixed(2))
      );
    },
    headersPagoDisposiciones() {
      return [
        { text: 'Saldo restante', value: 'remaining_principal' },
        { text: 'Interés generado', value: 'interes_calculado' },
        { text: 'Monto a capital', value: 'capitalAsignado' }
      ];
    },
    filteredDraws() {
      if (!this.search) return this.draws;
      const filtro = this.search.toLowerCase();
      return this.draws.filter(item => {
        return (
          (item.id || '').toLowerCase().includes(filtro) ||
          (item.enterprise_name || '').toLowerCase().includes(filtro) ||
          (item.disbursed_currency || '').toLowerCase().includes(filtro) ||
          (item.credit_line_currency || '').toLowerCase().includes(filtro) ||
          (item.status || '').toLowerCase().includes(filtro) ||
          String(item.draw_amount).includes(filtro) ||
          String(item.disbursed_amount).includes(filtro)
        );
      });
    }
  },
  beforeMount() {
    this.getDraws();
  },
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
</style>
